import { useEffect, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Row, Select, Space, Spin, Typography, message } from 'antd';
import axios from 'axios';
import { AiOutlineInfoCircle } from 'react-icons/ai';

import SectionCard from '../../../components/sectionCard/SectionCard';
import StepFooter from '../../../components/stepFooter/StepFooter';
import Order from './Order';
import useAddExpressDeliveryStore from './store';
import useOrderTabs from './useOrderTabs';

const { Option } = Select;
const { Text } = Typography;

/** Формын талбарууд хэт өргөн дэлгэц дээр тарж харагдахгүй байх хязгаар */
const FORM_MAX_WIDTH = 960;

/** Нэг захиалгад нэмж болох дэд захиалгын дээд тоо */
const MAX_ORDERS = 12;

const Step1 = ({ nextStep }) => {
  const {
    addresses,
    step1Values,
    setStep1Values,
    step1FormValues,
    setStep1FormValues,
    reference,
    deliveryTime,
    setReference,
    products,
    setProducts,
    addressDetails,
    positions,
    setDeliveryTime,
  } = useAddExpressDeliveryStore();
  const { getTab, setTab, removeTab } = useOrderTabs();
  const [form] = Form.useForm();
  const orders = Form.useWatch('orders', form);
  const [solvedPrice, setSolvedPrice] = useState();
  const [submitting, setSubmitting] = useState(false);
  // Салбар, хүргэлтийн төрөл, барааны хэмжээний сонголтууд эдгээр хүсэлтээс ирнэ
  const [referenceLoading, setReferenceLoading] = useState(true);
  const [productsLoading, setProductsLoading] = useState(true);
  const deliveryType = reference?.type;
  const contractType = reference?.contract?.data?.contractType;

  const onFinish = (values) => {
    let result = {
      ...(values || {}),
      orders: values?.orders?.map((item, i) => {
        return {
          ...item,
          addressDetails: addressDetails[i],
          address: [
            addresses?.[i]?.aimagHotList?.find((el) => el?.addressId === item?.aimagHot),
            addresses?.[i]?.sumDuuregList?.find((el) => el?.addressId === item?.sumDuureg),
            addresses?.[i]?.bagHorooList?.find((el) => el?.addressId === item?.bagHoroo),
          ],
        };
      }),
    };
    let selectedDeliveryType = null;
    selectedDeliveryType = deliveryTime === 'deliveryexpress' ? 'express' : 'regular';

    const paymentArray = result?.orders?.map((item, index) => {
      const product = products?.filter((product) => product.attributes?.size === item?.size);
      const payload = {
        product: product,
        address: item?.address,
        type: selectedDeliveryType,
        deliveryType: deliveryTime,
        position: positions[index],
        index,
      };
      return payload;
    });

    const pickUpLocationCode = values?.merchantCode;
    if (values.orders.find((item) => item.phoneNumber).phoneNumber.length === 8) {
      setSubmitting(true);
      axios
        .post(`/api/v1.0/request/calculateDirectPrice`, {
          pickUpLocationCode: pickUpLocationCode,
          solvedPrice,
          orders: paymentArray,
          contractType: contractType?.find((item) => item === 'D'),
          type: deliveryType,
          deliveryType: deliveryTime,
        })
        .then(({ data }) => {
          let totalPrice = 0;
          let totalDeliveryPrice = 0;
          let totalExecutionPrice = 0;
          let totalExpressPrice = 0;
          let totalExpressExceededPrice = 0;

          if (paymentArray.length > 1) {
            totalPrice = data.result.reduce((count, item) => count + (item?.totalAmount || 0), 0);
            totalDeliveryPrice = data.result.reduce(
              (count, item) => count + (item?.deliveryAmount?.totalPrice || 0),
              0
            );
            totalExecutionPrice = data.result.reduce(
              (count, item) => count + (item?.executionAmount?.totalPrice || 0),
              0
            );
            totalExpressPrice = data.result.reduce(
              (count, item) => count + (item?.expressAmount?.totalPrice || 0),
              0
            );
            totalExpressExceededPrice = data.result.reduce(
              (count, item) => count + (item?.expressAmount?.eachLengthKmPrice || 0),
              0
            );
          } else {
            totalPrice = data.result.totalAmount;
            totalDeliveryPrice = data.result.deliveryAmount?.totalPrice;
            totalExecutionPrice = data.result.executionAmount?.totalPrice;
            totalExpressPrice = data.result.expressAmount?.totalPrice;
            totalExpressExceededPrice = data.result.expressAmount?.eachLengthKmPrice;
          }
          const calculatedPrices = {
            result: data.result,
            totalPrice,
            totalDeliveryPrice,
            totalExecutionPrice,
            totalExpressPrice,
            totalExpressExceededPrice,
          };

          setStep1Values({
            deliveryTime: selectedDeliveryType,
            contractType,
            ...values,
            orders: result?.orders,
            ...calculatedPrices,
          });
          nextStep();
        })
        // Алдааны тайлбарыг axios interceptor өөрөө харуулна — товчийг л сэлбэнэ
        .finally(() => setSubmitting(false));
    } else {
      message.error('Та 8 оронтой утасны дугаар оруулна уу.');
    }
  };

  const initialOrder = {
    merchantCode: undefined,
    orders: [
      {
        deliveryType: '',
        aimagHot: '',
        sumDuureg: '',
        bagHoroo: '',
        size: '',
        phoneNumber: '',
        firstName: '',
        deliveryDetail: '',
        notes: [],
        orderDescription: '',
      },
    ],
  };

  useEffect(() => {
    axios
      .get(`/api/v1/request/delivery-reference`)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          setReference(data?.result);
          const contractServiceTypes = [
            ...new Set(data?.result?.contract?.data?.availableService.map((item) => item.type)),
          ];
          if (contractServiceTypes.length <= 1) {
            setSolvedPrice(contractServiceTypes?.[0] === 'B2B' ? 'B2Bprice' : 'B2Cprice');
          }
        }
      })
      .catch((err) => {
        console.error('delivery-reference error: ', err);
      })
      .finally(() => setReferenceLoading(false));

    axios
      .get(`/api/v1.0/product/defaultProducts`)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          setProducts(data?.result);
        }
      })
      .catch((err) => {
        console.error('defaultProducts error: ', err);
      })
      .finally(() => setProductsLoading(false));
    //eslint-disable-next-line
  }, []);

  const contractServiceTypes = [
    ...new Set(reference?.contract?.data?.availableService.map((item) => item.type)),
  ];

  const SOLVED_TYPE = contractServiceTypes.map((item) => {
    return {
      value: item === 'B2B' ? 'B2Bprice' : 'B2Cprice',
      label: item,
    };
  });

  const handleCalcPrice = (type) => {
    setSolvedPrice(type);
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      /**
       * Refresh хийхэд бөглөсөн мэдээлэл сэргэнэ: `step1FormValues` нь бичиж
       * байх зуур draft-д хадгалагддаг, `step1Values` нь алхмыг баталсан утга.
       */
      initialValues={
        step1FormValues ?? (Object.keys(step1Values).length > 2 ? step1Values : initialOrder)
      }
      onValuesChange={(_, allValues) => setStep1FormValues(allValues)}
    >
      <Spin spinning={referenceLoading || productsLoading}>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          <SectionCard icon={<AiOutlineInfoCircle />} title="Бараа татах салбар сонгох">
            <Row gutter={16} style={{ maxWidth: FORM_MAX_WIDTH }}>
              {contractServiceTypes.length > 1 && (
                <Col xs={24} sm={12} xl={8}>
                  <Form.Item label="Нөхцөл" required style={{ marginBottom: 0 }}>
                    <Select
                      value={solvedPrice}
                      onChange={handleCalcPrice}
                      options={SOLVED_TYPE}
                      placeholder="Сонгох"
                    />
                  </Form.Item>
                </Col>
              )}

              <Col xs={24} sm={12} xl={8}>
                <Form.Item
                  label="Бараа татах салбар"
                  name="merchantCode"
                  rules={[{ required: true, message: 'Салбараа сонгоно уу!' }]}
                  style={{ marginBottom: 0 }}
                >
                  <Select placeholder="Мерчант салбарын нэр">
                    {reference?.branches?.types?.map((item) => (
                      <Option value={item} key={item}>
                        {reference?.branches?.detail?.[item]?.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {!contractType?.includes('O') && (
                <Col xs={24} sm={12} xl={8}>
                  <Form.Item
                    label="Хүргэлтийн хугацаа"
                    name="deliveryTime"
                    rules={[{ required: true, message: 'Хүргэлтийн хугацаа сонгоно уу.' }]}
                    style={{ marginBottom: 0 }}
                  >
                    <Select onChange={setDeliveryTime} placeholder="Сонгох">
                      {deliveryType?.type?.map((type) => {
                        const item = deliveryType?.detail[type];
                        if (type === 'deliveryselfproclaim') return null;
                        //хэрэглэгчийн гэрээ ondemand байвал шуурхай хүргэлт байхгүй
                        if (contractType?.includes('O') && type === 'express') return null;
                        return (
                          <Option key={type} value={type} label={item}>
                            {item}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              )}
            </Row>
          </SectionCard>

          <Form.List name="orders">
            {(fields, { add, remove }) => (
              <Space direction="vertical" size={16} style={{ width: '100%' }}>
                {fields.map((field) => (
                  <Order
                    key={field.key}
                    field={field}
                    form={form}
                    order={orders?.length > field.name ? orders[field.name] : null}
                    remove={remove}
                    /* Хаягийн таб нь URL-ийн `?tab=`-д захиалгын дугаараар хадгалагдана */
                    activeTab={getTab(field.name)}
                    onChangeTab={(tab) => setTab(field.name, tab)}
                    onRemoveTab={() => removeTab(field.name)}
                  />
                ))}

                {fields.length < MAX_ORDERS && (
                  <Button
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    type="dashed"
                    size="large"
                    block
                  >
                    Захиалга нэмэх
                  </Button>
                )}
              </Space>
            )}
          </Form.List>

          <StepFooter
            loading={submitting}
            extra={
              orders?.length > 0 ? (
                <Text type="secondary">
                  Захиалгын тоо: <Text strong>{`${orders.length} / ${MAX_ORDERS}`}</Text>
                </Text>
              ) : null
            }
          />
        </Space>
      </Spin>
    </Form>
  );
};

export default Step1;
